import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import NavigationDropDownOptions from './NavigationDropDownOptions';

const NavigationDropDown = ({ tabs }) => {
  const tab = tabs.find(({ selected }) => selected);
  return (
    <>
      <Icon name={tab?.dropDownIcon} />
      <Dropdown className="aridhia-navigation-dropdown" inline text={tab?.name}>
        <Dropdown.Menu>
          <NavigationDropDownOptions tabs={tabs} />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NavigationDropDown;
